import { css } from "@emotion/react";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import type { ReactNode } from "react";

import { RenderDelay } from "../RenderDelay.js";

export interface MainEmptyStateProps {
  className?: string;
  heading: ReactNode;
  text?: ReactNode;
  children?: ReactNode;
}

export const MainEmptyState = (props: MainEmptyStateProps) => {
  const { heading, text, children, ...others } = props;
  const { spacing } = useTheme();

  return (
    <div
      css={css`
        block-size: max-content;
        margin-inline: auto;
        padding-block-start: ${spacing(8)};

        display: grid;
        align-items: center;
        justify-items: center;
      `}
      {...others}
    >
      <Typography
        css={css`
          margin-block-end: ${spacing(3)};
        `}
        variant="h5"
        component="h2"
        align="center"
      >
        {heading}
      </Typography>
      {text && (
        <Typography
          css={css`
            min-inline-size: 0;
            max-inline-size: 60ch;
            margin-block-end: ${spacing(6)};

            overflow-wrap: break-word;
          `}
          variant="body2"
          component="div"
          align="center"
        >
          {text}
        </Typography>
      )}
      {children}
    </div>
  );
};

export const MainLoadingState = (props: MainEmptyStateProps) => (
  <RenderDelay>
    <MainEmptyState {...props}>
      <CircularProgress />
    </MainEmptyState>
  </RenderDelay>
);
